import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private _user: string;
  private _client: number;
  private _token: string;

  constructor() { 

    this._user = localStorage.getItem('u');
    this._client = Number(localStorage.getItem('c'));
    this._token = localStorage.getItem('t');
  }

  get user() { return this._user; }
  get client() { return this._client; }
  get token() { return this._token; }
  get isLoggedIn() { return this._user != null }
  
  login(user: string, client: number, token: string) {
    this._user = user;
    this._client = client;
    this._token = token;

    localStorage.setItem('u', this._user);
    localStorage.setItem('c', String(this._client));
    localStorage.setItem('t', this._token);
  }

  logout() {
    this._user = null;
    this._client = 0;
    this._token = null;

    localStorage.clear();
  }
}
